import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Header from '../../Components/Header/Header'
import Colors from '../../Constants/Colors'
import CustomPagination from '../../Components/CustomPagination/CustomPagination'
import {
  apiCallUserApplication,
  apiCallUserApplicationApprove
} from '../../Core/Apicall'
import {
  setLoadingFalse,
  setLoadingTrue
} from '../../Config/Actions/loadingActions'
import EmptyData from '../../Components/EmptyData/EmptyData'
import UserApplicationRenderItem from './UserApplicationRenderItem'
import UserApplicationModal from './UserApplicationModal'
import { CustomCommonBox } from '../../Components/CustomCommonBox/CustomCommonBox'
import { useNavigate } from 'react-router-dom'
function UserApplication() {
  const dispatch = useDispatch()
  const [userListData, setUserListData] = useState()
  const [userTotalInActive, setUserTotalInActive] = useState(0)
  const [userTotalCount, setUserTotalCount] = useState(0)
  const [isVisible, setIsVisible] = useState(false)
  const [initialPage, setInitialPage] = useState(0)
  const [currentUserId, setCurrentUserId] = useState()

  useEffect(() => {
    onApiCallUserList(0)
  }, [])

  const onApiCallUserList = async selectedPage => {
    dispatch(setLoadingTrue())
    const param = {
      offset: selectedPage + 1,
      limit: 15
    }
    try {
      const res = await apiCallUserApplication(param)
      setUserTotalCount(res?.totalPendingApplications)
      setUserTotalInActive(res?.totalRejectedApplications)
      setInitialPage(selectedPage ?? 0)
      setUserListData(res)
    } catch (error) {
      console.error('Error fetching user list:', error)
    } finally {
      dispatch(setLoadingFalse())
    }
  }
  const registrationTotal = [
    {
      label: 'Total Pending Application',
      count: userTotalCount,
      color: Colors.darkBlue
    },
    {
      label: 'Total Reject Application',
      count: userTotalInActive,
      color: Colors.darkRed
    }
  ]
  const onApprove = async data => {
    dispatch(setLoadingTrue())
    const param = {
      userId: data.userId,
      isApprove: true,
      isReject: false,
      userType: data?.applicationUserType
    }
    try {
      await apiCallUserApplicationApprove(param)
      onApiCallUserList(0)
    } catch (error) {
      console.error('Error toggling user status:', error)
    } finally {
      dispatch(setLoadingFalse())
    }
  }

  const onReject = async rejectComment => {
    dispatch(setLoadingTrue())
    const param = {
      userId: currentUserId.userId,
      email: currentUserId.userEmail,
      isReject: true,
      isApprove: false,
      message: rejectComment
    }
    try {
      await apiCallUserApplicationApprove(param)
      onApiCallUserList(0)
      setIsVisible(false)
    } catch (error) {
      console.error('Error toggling user status:', error)
    } finally {
      dispatch(setLoadingFalse())
    }
  }

  const navigate = useNavigate()

  const onClickUser = (item) => {
    navigate("/UserProfile", {
      state: {
        userId: item.userId,
        isFullProfile: false
      },
    })
  }

  const onClickTabOpen = () => { }
  return (
    <div>
      <Header name={'User Application'} />
      <div className='register-flex'>
        <div className='astrologer-inner'>
          <div className='frame-container'>
            <div className='frame-div'>
              {registrationTotal.map(tab => (
                <CustomCommonBox
                  key={tab.label}
                  label={tab.label}
                  onClickTabOpen={onClickTabOpen}
                  color={tab.color}
                  count={tab.count}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {userListData?.data.length != 0 && (
        <div style={{}} className='register-style-stretch'>
          <div className='lastWeekEndDiv Total-Event'>
            <div className='user_title'>User Application list</div>
            <div className='transparentWhite'>
              <nav className='grid-cols grid_7 fontSize16WithoutFlex transparentWhite-padding'>
                {[
                  { label: 'Name', value: '22%' },
                  { label: 'Username', value: '12%' },
                  { label: 'Contact', value: '20%' },
                  { label: 'Date of Birth', value: '8%' },
                  { label: 'UserType', value: '14%' },
                  { label: 'New UserType', value: '14%' },
                  { label: 'Status', value: '10%' },
                  { label: '', value: '10%' }
                ].map((items, index) => (
                  <div
                    key={index.toString()}
                    style={{ width: items.value }}
                    className='user_name'
                  >
                    {items.label}
                  </div>
                ))}
              </nav>
              <UserApplicationRenderItem
                onClickUser={(data) => onClickUser(data)}
                onApprove={data => onApprove(data)}
                currentUsers={userListData?.data}
                setIsVisible={data => {
                  setIsVisible(true)
                  setCurrentUserId(data)
                }}
              />
            </div>
          </div>
        </div>
      )}

      {userListData?.data.length === 0 && (
        <div className='empty-centered'>
          <EmptyData />
        </div>
      )}

      {userListData?.data.length !== 0 && (
        <div className='Custom-Pagination'>
          <CustomPagination
            pageCount={Math.ceil(userListData?.totalRejectedApplications / 15)}
            pageRangeDisplayed={3}
            initialPage={initialPage}
            marginPagesDisplayed={1}
            onPageChange={({ selected }) => {
              onApiCallUserList(selected)
            }}
          />
        </div>
      )}

      {isVisible && (
        <UserApplicationModal
          onReject={rejectComment => onReject(rejectComment)}
          isVisible={isVisible}
          handleClose={() => {
            setCurrentUserId()
            setIsVisible(false)
          }}
        />
      )}
    </div>
  )
}

export default UserApplication
